import { combineReducers } from 'redux'
import { createSlice } from '@reduxjs/toolkit'

export const efriDetailSlice = createSlice({
  name: 'efriDetail',
  initialState: null,
  reducers: {
    efriDetailRequest: {
      reducer() {
        return { loading: true }
      },
    },
    efriDetailSuccess: {
      reducer(state, action) {
        const data = action.payload
        return data
      },
    },
    efriDetailFailed: {
      reducer() {
        return {}
      },
    },
    uploadEfrOssFile: {
      reducer(state) {
        return state
      },
    },
    uploadEfrOssFileRequest: {
      reducer(state) {
        return state
      },
    },
    uploadEfrOssFileSuccess: {
      reducer(state, action) {
        const data = action.payload
        return state
      },
    },
    uploadEfrOssFileFailed: {
      reducer(state) {
        return state
      },
    },
    getEfrOssFileRequest: {
      reducer(state) {
        return state
      },
    },
    getEfrOssFileSuccess: {
      reducer(state, action) {
        const data = action.payload
        const url = data.replace('https://files.padi.com.cn/', '')
        const { efrfiles, ...detail } = state
        return { efrfiles: efrfiles ? [data, ...efrfiles] : [data], ...detail }
      },
    },
    getEfrOssFileFailed: {
      reducer(state) {
        return state
      },
    },
    removeEfrFile: {
      reducer(state, action) {
        const data = action.payload
        const url = data.replace('https://files.padi.com.cn/', '')
        const { efrfiles, ...detail } = state
        const newEfrfiles = efrfiles.filter((item) => item !== data)
        return { efrfiles: newEfrfiles, ...detail }
      },
    },
  },
})

export const {
  efriDetailRequest,
  efriDetailSuccess,
  efriDetailFailed,
  uploadEfrOssFile,
  uploadEfrOssFileRequest,
  uploadEfrOssFileSuccess,
  uploadEfrOssFileFailed,
  getEfrOssFileRequest,
  getEfrOssFileSuccess,
  getEfrOssFileFailed,
  removeEfrFile,
} = efriDetailSlice.actions

export const efriDetail = {
  request: (data) => efriDetailRequest(data),
  success: (data) => efriDetailSuccess(data),
  failure: (error) => efriDetailFailed(error),
}

export const uploadEfrAttachFile = {
  request: () => uploadEfrOssFileRequest(),
  success: (data) => uploadEfrOssFileSuccess(data),
  failure: (error) => uploadEfrOssFileFailed(error),
}

export const getEfrOssFile = {
  request: () => getEfrOssFileRequest(),
  success: (data) => getEfrOssFileSuccess(data),
  failure: (error) => getEfrOssFileFailed(error),
}

export const efrtListSlice = createSlice({
  name: 'efrtList',
  initialState: {},
  reducers: {
    skipEfrtApplicationsPage: {
      reducer(state, action) {
        return state
      },
    },
    efrtListRequest: {
      reducer(state) {
        return state
      },
    },
    efrtListSuccess: {
      reducer(state, action) {
        const data = action.payload
        return data
      },
    },
    efrtListFailed: {
      reducer(state) {
        return state
      },
    },
  },
})

export const { efrtListRequest, efrtListSuccess, efrtListFailed, skipEfrtApplicationsPage } = efrtListSlice.actions

export const getEfrtListRequest = {
  request: () => efrtListRequest(),
  success: (data) => efrtListSuccess(data),
  failure: (error) => efrtListFailed(error),
}

export const efrtDetailSlice = createSlice({
  name: 'efrtDetail',
  initialState: {},
  reducers: {
    efrtDetailRequest: {
      reducer() {
        return {}
      },
    },
    efrtDetailSuccess: {
      reducer(state, action) {
        const data = action.payload
        return data
      },
    },
    efrtDetailFailed: {
      reducer() {
        return {}
      },
    },
    uploadEfrtOssFile: {
      reducer(state) {
        return state
      },
    },
    uploadEfrtOssFileRequest: {
      reducer(state) {
        return state
      },
    },
    uploadEfrtOssFileSuccess: {
      reducer(state, action) {
        const data = action.payload
        return state
      },
    },
    uploadEfrtOssFileFailed: {
      reducer(state) {
        return state
      },
    },
    getEfrtOssFileRequest: {
      reducer(state) {
        return state
      },
    },
    getEfrtOssFileSuccess: {
      reducer(state, action) {
        const data = action.payload
        const url = data.replace('https://files.padi.com.cn/', '')
        const { efrfiles, ...detail } = state
        return { efrfiles: efrfiles ? [data, ...efrfiles] : [data], ...detail }
      },
    },
    getEfrtOssFileFailed: {
      reducer(state) {
        return state
      },
    },
  },
})

export const {
  efrtDetailRequest,
  efrtDetailSuccess,
  efrtDetailFailed,
  uploadEfrtOssFile,
  uploadEfrtOssFileRequest,
  uploadEfrtOssFileSuccess,
  uploadEfrtOssFileFailed,
  getEfrtOssFileRequest,
  getEfrtOssFileSuccess,
  getEfrtOssFileFailed,
} = efrtDetailSlice.actions

export const efrtDetail = {
  request: () => efrtDetailRequest(),
  success: (data) => efrtDetailSuccess(data),
  failure: (error) => efrtDetailFailed(error),
}

export const uploadEfrtAttachFile = {
  request: () => uploadEfrtOssFileRequest(),
  success: (data) => uploadEfrtOssFileSuccess(data),
  failure: (error) => uploadEfrtOssFileFailed(error),
}

export const getEfrtOssFile = {
  request: () => getEfrtOssFileRequest(),
  success: (data) => getEfrtOssFileSuccess(data),
  failure: (error) => getEfrtOssFileFailed(error),
}

const efriReducer = combineReducers({
  efrtList: efrtListSlice.reducer,
  efriDetail: efriDetailSlice.reducer,
  efrtDetail: efrtDetailSlice.reducer,
})

export default efriReducer
